export default "/images/warning_popup.svg?df80ed8bbc5e180f020ce9ab51a3d428";